import { render, staticRenderFns } from "./study-mian.vue?vue&type=template&id=61cd99c2&scoped=true&"
import script from "./study-mian.vue?vue&type=script&lang=ts&"
export * from "./study-mian.vue?vue&type=script&lang=ts&"
import style0 from "./study-mian.vue?vue&type=style&index=0&id=61cd99c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cd99c2",
  null
  
)

export default component.exports